/* eslint-disable prettier/prettier */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("@/view/greeting.vue"),
      name: "greeting",
    },
    {
      path: "/home",
      component: () => import("@/view/home.vue"),
      name: "home",
    },
    {
      path: "/administration",
      component: () => import("@/view/administration.vue"),
      name: "administration",
      beforeEnter: (to, from, next) => {
        console.log(to.query.c, from);
        // reject the navigation
        if (to.query.c == "encenmontilivi23") {
          next();
        } else {
          return false;
        }
      },
    },
    {
      path: "/live",
      component: () => import("@/view/live.vue"),
      name: "live",
      beforeEnter: (to, from, next) => {
        console.log(to.query.c, from);
        // reject the navigation
        if (to.query.c == "encenmontilivi23") {
          next();
        } else {
          return false;
        }
      },
    },
    {
      path: "/live2",
      component: () => import("@/view/live2.vue"),
      name: "live2",
      beforeEnter: (to, from, next) => {
        console.log(to.query.c, from);
        // reject the navigation
        if (to.query.c == "encenmontilivi23") {
          next();
        } else {
          return false;
        }
      },
    },
    {
      path: "/results",
      component: () => import("@/view/results.vue"),
      name: "results",
      beforeEnter: (to, from, next) => {
        console.log(to.query.c, from);
        // reject the navigation
        if (to.query.c == "encenmontilivi23") {
          next();
        } else {
          return false;
        }
      },
    },
    {
      path: "/create",
      component: () => import("@/view/create.vue"),
      name: "create",
    },
    {
      path: "/delivered",
      component: () => import("@/view/delivered.vue"),
      name: "delivered",
    },
  ],
});
router.beforeEach(async (to, from, next) => {
  // canUserAccess() returns `true` or `false`
  // console.log(to, from);
  // to.meta = from.query;
  next();
});

export default router;
